import axios from 'axios';
import {API} from '../../api/api';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {parseJwt_Expired} from '../../helper/parseJwtExpired';

export const chooseTestValidateAction = createAsyncThunk(
    'chooseTestValidateAction',
    async function (params, {rejectWithValue}) {
        const access_token_toxometris = localStorage.getItem('access_token_toxometris');
        access_token_toxometris && parseJwt_Expired(access_token_toxometris);

        try {
            const response = await axios.post(`${API.BASE_URL}/validate_smiles`,
                JSON.stringify(params), {
                    withCredentials: true,
                    headers: {
                        'Accept': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${access_token_toxometris}`,
                        'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
                    }
                });
            const {data, status} = response;
            if (status === 200 && data.status === 'success' && data?.result?.length > 0) {
                return response.data
            } else {
                return rejectWithValue(response.data);
            }
        } catch (e) {
            return {message: e?.message || 'Something wnt wrong, please try later'}
        }
    }
);
const chooseTestValidateSlice = createSlice({

    name: 'CHOOSE_TEST_VALIDATE_TOOLKIT',

    initialState: {
        loading: null,
        validateResult: [],
        platformRequestId: "",
        error: null,
        status: null
    },
    reducers: {
        updatePlatformRequestId: (state, action) => {
            state.platformRequestId = action.payload;
          },
    },

    extraReducers: {
        [chooseTestValidateAction.pending]: (state) => {
            state.status = 'CHOOSE_TEST_VALIDATE_REQUEST';
            state.error = null;
            state.loading = true;
        },

        [chooseTestValidateAction.fulfilled]: (state, action) => {
            state.status = 'CHOOSE_TEST_VALIDATE_SUCCESS';
            state.validateResult = action.payload;
            state.loading = false;
            state.error = null;
        },

        [chooseTestValidateAction.rejected]: (state, action) => {
            state.status = 'CHOOSE_TEST_VALIDATE_FAIL';
            state.loading = false;
            state.validateResult = [];
            state.error = action.payload || {message: 'Something went wrong, please try later'};
        },
    }
});

export default chooseTestValidateSlice.reducer;
export const {updatePlatformRequestId} = chooseTestValidateSlice.actions;
